export default __webpack_public_path__ + "static/media/image_22.f356369a.jpg";